module.exports = __webpack_public_path__ + "img/puls.8dfc445a.png";